$(document).ready(function () {

    function ScrollToResults() {
        $('html, body').animate({
            scrollTop: eval($('.ajaxResults').offset().top - 230)
        }, 1000);
    }

    if ($('[data-search=faqs]').length > 0) {
        //Scrolls down the page if a question in the URL
        var question = getUrlParameter('question');
        if (question != '' && typeof question != 'undefined') {
            $('html, body').animate({
                scrollTop: eval($('.' + question).offset().top - 230)
            }, 1000);
        }

        //Scrolls down the page if a category is selected
        var category = getUrlParameter('category');
        if ((category != '' && typeof category != 'undefined') &&
            (question === '' || typeof question === 'undefined')) {
            ScrollToResults();
        }

        //prevent enter key submitting the form
        $('[data-search=faqs]').keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                ScrollToResults();
                return false;
            }
        });

        $('[data-search=faqs]').autocomplete({
            minLength: -1,
            source: function (request, response) {
                $('.ajaxResults').empty();

                if (request.term.length < 2) {
                    $('.resultsServerSide').show();
                    $('.searchedForTextWrapper').hide();
                    return;
                }

                $.ajax({
                    url: '/FAQ/Search',
                    type: 'GET',
                    data: { searchTerm: request.term, category: '', terminalArea: '' },
                    success: function (data) {
                        $('.searchedForText').text('You searched for: "' + request.term + '"');
                        $('.searchedForTextWrapper').show();

                        if (data.length == 0) {
                            $('.resultsServerSide').hide();
                            $('.ajaxResults').empty().append('<h4>No Results found, please try again</h4>');
                        }

                        response(
                            $.map(data, function (item) {
                                var faq = { label: item.question, Question: item.question, Answer: item.answer, Link: item.link, Categories: item.categories, TerminalAreas: item.terminalAreas };
                                if (faq.Question !== 'none') {
                                    $('.resultsServerSide').hide();
                                    if (faq.Link === '' || !faq.Link) {
                                        $('.ajaxResults').append('<h4>' + faq.Question + '</h4>' +
                                            '<div>' + faq.Answer + '</div>' +
                                            '<p>In: ' + faq.Categories + '</p>' +
                                            '<hr>');
                                    }
                                    else {
                                        $('.ajaxResults').append('<h4>' + faq.Question + '</h4>' +
                                            '<div>' + faq.Answer + '</div>' +
                                            '<p>In: ' + faq.Categories + '</p>' +
                                            "<p><a href='" + faq.Link.replace('~', '') + "' class='btn'>Visit page <i class='fa fa-angle-right'></i></a></p>" +
                                            '<hr>');
                                    }
                                }
                            })
                        );
                    }
                });
            }
        });
    }

    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return '';
    };
});